// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ox-0";
export var leftAlign = "_ox-4";
export var listItem = "_ox-2";
export var listItemWrapper = "_ox-1";
export var operationText = "_ox-3";